import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import auth from '../auth';
import User from '../images/user.png'
import Logo from '../images/logo.svg'

const Navbar = () => {
    const user = useSelector((state) => state?.user?.user);
    const [openMenu, setOpenMenu] = useState(false)

    const logout = () => {
        auth().goLogout()
    }

    return (
        <>
            {openMenu &&
                <div className='absolute top-0 right-0 bg-transparent w-full h-full z-20' onClick={() => setOpenMenu(false)}></div>
            }
            <nav className="w-full z-30 border-b" style={{background: 'rgba(17,17,17,0.85)', backdropFilter: 'blur(16px)', borderColor: 'rgba(255,255,255,0.06)'}}>
                <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto px-4 py-3">
                    {/* Logo */}
                    <a href="/" className="flex items-center gap-2 group">
                        <img src={Logo} className="h-7 md:h-8" alt="Digipayments Logo" />
                        <span className="text-white font-semibold text-base md:text-lg tracking-tight group-hover:opacity-90 transition-opacity">Digipayments</span>
                    </a>

                    {/* Nav links - center */}
                    <div className={`${openMenu ? '' : 'hidden'} z-50 items-center justify-between ml-auto mr-4 w-full md:flex md:w-auto md:order-1`} id="navbar-user">
                        <ul className="flex flex-col md:flex-row md:items-center md:gap-1 font-medium p-4 md:p-0 mt-4 md:mt-0">
                            <li>
                                <a href="/" className="block px-3 py-2 rounded-lg text-sm nav-link hover:bg-white/5 transition-colors duration-200">Inicio</a>
                            </li>
                            {user !== null && (
                                <>
                                    <li>
                                        <a href="/wallet" className="block px-3 py-2 rounded-lg text-sm nav-link hover:bg-white/5 transition-colors duration-200">Wallet</a>
                                    </li>
                                    <li>
                                        <a href="/transactions" className="block px-3 py-2 rounded-lg text-sm nav-link hover:bg-white/5 transition-colors duration-200">Historial</a>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>

                    {/* Right side */}
                    <div className="flex items-center md:order-2 gap-2">
                        {user === null ? (
                            <>
                                <Link to="/login" className="text-sm px-3 py-2 rounded-lg nav-link hover:bg-white/5 transition-colors duration-200">Iniciar Sesión</Link>
                                <Link to="/register" className="text-sm py-2 px-5 rounded-full button-action">Crear Cuenta</Link>
                            </>
                        ) : (
                            <div className='flex items-center relative'>
                                <button
                                    type="button"
                                    onClick={() => setOpenMenu(!openMenu)}
                                    className="flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-full border hover:border-white/20 transition-colors duration-200 z-50"
                                    style={{borderColor: 'rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)'}}
                                    id="user-menu-button"
                                >
                                    <img className="w-7 h-7 rounded-full" src={User} alt="user photo" />
                                    <span className="text-xs text-gray-300 hidden md:block">{user?.user?.first_name}</span>
                                    <svg className="w-3 h-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </button>

                                {/* Dropdown */}
                                <div className={`${openMenu ? 'md:block' : 'hidden'} hidden z-50 absolute right-0 top-full mt-2 w-52 rounded-xl border overflow-hidden`}
                                    style={{background: '#1e1e1e', borderColor: 'rgba(255,255,255,0.08)', boxShadow: '0 8px 32px rgba(0,0,0,0.5)'}}>
                                    <div className="px-4 py-3 border-b" style={{borderColor: 'rgba(255,255,255,0.06)'}}>
                                        <p className="text-sm font-semibold text-white">{`${user?.user?.first_name} ${user?.user?.last_name}`}</p>
                                        <p className="text-xs text-gray-400 truncate mt-0.5">{user?.user?.username}</p>
                                    </div>
                                    <ul className="py-1">
                                        <li>
                                            <a href="/account" className="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-200 hover:bg-white/5 hover:text-white transition-colors duration-150">
                                                <i className='bx bx-user text-gray-400'></i>
                                                Perfil
                                            </a>
                                        </li>
                                        <li>
                                            <a onClick={logout} className="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-200 hover:bg-white/5 hover:text-white transition-colors duration-150 cursor-pointer">
                                                <i className='bx bx-log-out text-gray-400'></i>
                                                Cerrar Sesión
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </nav>
        </>
    )
}
export default Navbar;
